import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import globalFunctions from './GlobalFunctions';
import './assets/css/main.css';
import { SnackbarProvider } from 'notistack';
import { theme } from './Theme';
import { ThemeProvider } from '@mui/material/styles';
import { ProjectConfig } from 'Global';

function App() {
  const [configLoaded, setConfigLoaded] = useState(false);

  

  useEffect(() => {
    /*PREVENT DEFAULT WEBFLOW FORM SUBMISSION
    =============================================*/
    globalFunctions.StopWebflowDefault();

    /*BUILD LOADER
    =============================================*/
    globalFunctions.BuildLoader();

    /*GET STORE CONFIGURATION
    =============================================*/
    const fetchStoreConfig = async () => {
      await globalFunctions.getStoreConfiguration();
      // Mark configuration as loaded after completion
      setConfigLoaded(true);
      console.log(`%c💾 Pennicart Version - ${ProjectConfig.version}`, "color: #7963ff")
    };
    
    fetchStoreConfig();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        {configLoaded ? (
          <Router>
            <AppRoutes />
          </Router>
        ) : null
        }
      </SnackbarProvider>
    </ThemeProvider>
  )
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  
    <App />
  // </React.StrictMode>
);

